import React, { useEffect, useRef } from "react";
import { PiDotsThreeBold } from "react-icons/pi";
import { CommunityFeedCommment, CommunityFeedType } from "../../types";
import { convertTimestamp } from "../../utils/timeConverter";
import { useSelector } from "react-redux";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";

type CommentMenuProps = {
  commentFeed: CommunityFeedCommment | undefined;
  communityFeed: CommunityFeedType | undefined;
  isEdited: boolean;
  handleDelete: (e: any) => void;
  openOption: boolean;
  deleteOption: boolean;
  setOpenOption: React.Dispatch<React.SetStateAction<boolean>>;
  loadFeeds: boolean;
  refetch?: () => void;
  setHideComment: React.Dispatch<React.SetStateAction<boolean>>;
  hideComment: boolean;
  handleOpenNotice: () => void;
  handleEdit: () => void;
  _image?: string
};

const CommentMenu: React.FC<CommentMenuProps> = ({
  commentFeed,
  communityFeed,
  handleEdit,
  isEdited,
  handleDelete,
  openOption,
  deleteOption,
  setOpenOption,
  loadFeeds,
  handleOpenNotice,
  _image,
}) => {
  const user = useSelector((state: any) => state.user.userDetails);

  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenOption(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenOption]);

 


  // const handleHideComment = () => {
  //   setHideComment(true);
  //   setOpenOption(false);
  // };

 
  return (
    <div
      className="relative flex w-full justify-between font-Rubik items-center lg:h-8 h-6 lg:mb-2"
      ref={containerRef}
    >
      <div className="flex w-[70%] lg:gap-4 gap-2 h-8 items-center lg:text-base">
        <div className="lg:w-8 lg:h-8 w-6 h-6">
          {_image ? (
            <img
              src={ipfsGatewayImage(_image!)}
              alt=""
              className="lg:w-8 lg:h-8 w-6 h-6 rounded-full"
            />
          ) : (
            <div className="lg:w-8 lg:h-8 w-6 h-6  bg-slate-100 flex items-center justify-center rounded-full">
              <CiUser size={15} />
            </div>
          )}
        </div>
        <div className=" text-[#01262F] text-xs font-medium">
          {`${commentFeed?.creator.firstName} ${commentFeed?.creator.lastName}`}
        </div>
        <div className=" text-[#646464] text-[10px] font-normal">
          {isEdited
            ? convertTimestamp(commentFeed?.updatedAt)
            : convertTimestamp(commentFeed?.createdAt)}
        </div>
      </div>
      {!loadFeeds ? (
        <PiDotsThreeBold
          size={22}
          onClick={() => setOpenOption(!openOption)}
          className="cursor-pointer"
        />
      ) : (
        <PiDotsThreeBold size={22} className="cursor-pointer" />
      )}
      {openOption &&
        (user.id === communityFeed?.creator.id ||
          user.id === commentFeed?.creator.id) && (
          <ul className="bg-white flex flex-col transition-all ease-in-out duration-100 justify-center px-4 items-center gap-[10px] absolute right-4 top-3 z-10  py-3 rounded-sm shadow-[1px_-1px_10px_5px_rgba(0,0,0,0.1)] font-semibold font-Poppins text-sm text-[#646464]">
            {user.id === commentFeed?.creator.id && (
              <li
                className="hover:rounded hover:bg-gray-100 py-1 px-3 cursor-pointer"
                onClick={handleEdit}
              >
                Edit
              </li>
            )}
            {(user.id === communityFeed?.creator.id ||
              user.id === commentFeed?.creator.id) && (
              <li
                className="hover:rounded hover:bg-gray-100 cursor-pointer py-1 px-2"
                onClick={handleOpenNotice}
              >
                Delete
              </li>
            )}

            {/* <li
            className="hover:rounded hover:bg-gray-100 py-1 px-3 cursor-pointer"
            onClick={handleHideComment}
          >
            Hide comment
          </li> */}
          </ul>
        )}
      {deleteOption && (
        <div className="fixed inset-0 w-full z-30 align-middle flex justify-center items-center transition-colors overflow-y-hidden bg-black/20">
          <div className="bg-[#FFF] lg:w-[60%] lg:h-[252px] h-[270px] w-[85%] shadow rounded-lg p-8 font-Rubik flex flex-col lg:gap-5">
            <h1 className=" lg:text-darkGreen lg:text-left text-black text-xs font-bold text-center mb-1 lg:mb-0 lg:text-base lg:font-medium">
              Delete comment
            </h1>
            <p className=" lg:text-base text-[10px] text-center lg:text-left text-[#67727E]">
              Are you sure you want to delete this comment? This will remove the
              comment and can’t be undone.
            </p>
            <div className="flex flex-col-reverse lg:flex-row mt-[29px] lg:mt-0 lg:justify-between lg:gap-0 text-[15px] font-Rubik font-medium text-white">
              <div
                className="lg:w-[131px] h-10 lg:h-[48px] border-[0.5] border-solid border-[#08080D] lg:border-0 w-full flex justify-center items-center text-midGreen lg:text-inherit lg:rounded rounded-md shadow lg:bg-[#67727E] text-center cursor-pointer hover:text-darkGreen active:ml-1 active:mt-px transition duration-75"
                onClick={handleOpenNotice}
              >
                NO, CANCEL
              </div>
              <div
                className="lg:w-[131px] w-full h-10 lg:h-[48px] flex justify-center items-center rounded-md mb-4 lg:mb-0 lg:rounded shadow bg-midGreen text-center cursor-pointer hover:text-lightGreen active:bg-white active:ease-linear transition duration-75"
                onClick={handleDelete}
              >
                YES, DELETE
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentMenu;
